export const UPDATE_BANK_ACCOUNT_SUCCESS = 'Bank account updated successfully.';
export const UPDATE_BANK_ACCOUNT_ERROR = 'Error in updating bank account.';
